import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { Component } from 'react';
import { INTEGRATION_KEY } from '../../state/integration/Constants';
import NewRainforestCreditCardWrapper from './NewRainforestCreditCardWrapper';
import RainforestCreditCardWrapper from './RainforestCreditCardWrapper';
import PaysafeCreditCardForm from "./paysafe.component.jsx";
import SquarePayment from "./squareComponent";
import StripeCreditCardForm from "./stripe.component.jsx";

let stripePromise = null
class CreditCardContainer extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            onSubmit: this.props.onSubmit || function () { },
            onClose: this.props.onClose || function () { },
            submitDisabled: this.props.submitDisabled,
            submitButton: this.props.submitButton,
            submitButtonStyle: this.props.submitButtonStyle,
            apiKey: this.props.apiKey,
            integrationKey: this.props.integrationKey,
            testMode: this.props.testMode,
            countryCode: this.props.countryCode,
            currency: this.props.currency,
            amount: this.props.amount,
            merchantId: this.props.merchantId,
            onPaymentIntentCompleted: this.props.onPaymentIntentCompleted || function () { },
            saveCard: this.props.saveCard || false,
            forceSaveCard: this.props.forceSaveCard || false,
            contactId: this.props.contactId || '',
            saveAndChargeLater: this.props.saveAndChargeLater || false,
            ignoreAuthentication: this.props.ignoreAuthentication || false,
            acceptedCardBrands: this.props.acceptedCardBrands || [],
        }

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            submitDisabled: nextProps.submitDisabled,
            apiKey: nextProps.apiKey,
            currency: nextProps.currency,
            amount: nextProps.amount,
            merchantId: nextProps.merchantId,
            saveCard: nextProps.saveCard || false,
        })
    }

    componentWillUnmount() {
        stripePromise = null
    }


    render() {
        if (!stripePromise && this.state.integrationKey === INTEGRATION_KEY.STRIPE) {
            stripePromise = loadStripe(this.state.apiKey)
        }
        if (!this.state.apiKey || !this.state.integrationKey) {
            return <div />
        }

        switch (this.state.integrationKey) {
            case INTEGRATION_KEY.STRIPE:
                return (
                    <Elements stripe={stripePromise}>
                        <StripeCreditCardForm
                            onSubmit={this.state.onSubmit}
                            submitButton={this.state.submitButton}
                            submitButtonStyle={this.state.submitButtonStyle}
                            submitDisabled={this.state.submitDisabled}
                            onPaymentIntentCompleted={this.state.onPaymentIntentCompleted}
                            saveCard={this.state.saveCard}
                            contactId={this.state.contactId}
                            saveAndChargeLater={this.state.saveAndChargeLater}
                            ignoreAuthentication={this.state.ignoreAuthentication}
                            locationId={this.props.locationId}
                            acceptedCardBrands={this.state.acceptedCardBrands}
                        >
                            {this.props.children}
                        </StripeCreditCardForm>
                    </Elements>
                )
            case INTEGRATION_KEY.PAYSAFE:
                return (
                    <PaysafeCreditCardForm
                        countryCode={this.state.countryCode}
                        onSubmit={this.state.onSubmit}
                        submitButton={this.state.submitButton}
                        submitButtonStyle={this.state.submitButtonStyle}
                        submitDisabled={this.state.submitDisabled}
                        apiKey={this.state.apiKey}
                        testMode={this.state.testMode}
                        currency={this.state.currency}
                        amount={this.state.amount}
                        merchantId={this.state.merchantId}
                        saveCard={this.state.saveCard}
                    >
                        {this.props.children}
                    </PaysafeCreditCardForm>
                )
            case INTEGRATION_KEY.SQUARE:
            case INTEGRATION_KEY.SQUARE_PAYMENTS:
                return (
                    <SquarePayment
                        countryCode={this.state.countryCode}
                        onSubmit={this.state.onSubmit}
                        submitButton={this.state.submitButton}
                        submitButtonStyle={this.state.submitButtonStyle}
                        submitDisabled={this.state.submitDisabled}
                        apiKey={this.state.apiKey}
                        testMode={this.state.testMode}
                        currency={this.state.currency}
                        amount={this.state.amount}
                        locationId={this.state.merchantId}
                        saveCard={this.state.saveCard}>
                        {this.props.children}
                    </SquarePayment>
                )
            case INTEGRATION_KEY.RAINFOREST:
                if (this.props.showSaveCardComponent) {
                    return (
                        <NewRainforestCreditCardWrapper
                            refreshContact={this.props.refreshContact}
                            contactId={this.state.contactId}
                            onCardAdded={this.props.onCardAdded}
                            locationId={this.props.locationId}
                        />
                    )
                } else {
                    return (
                        <RainforestCreditCardWrapper
                            amount={this.state.amount}
                            buildMetaData={this.props.buildMetaData}
                            onClose={this.props.onClose}
                            proposalHash={this.props.proposalHash}
                            paymentAccount={this.props.paymentAccount}
                            forceSaveCard={this.state.forceSaveCard}
                            buttonColor={this.state.submitButtonStyle?.backgroundColor}
                        />
                    )
                }
            default:
                return <div />

        }
    }
}
export default CreditCardContainer





// WEBPACK FOOTER //
// ./src/common/credit-card/container.component.jsx